import ReactMarkdown from 'react-markdown';
import { listing as listingType } from '../proptypes/index';
import DemoCarousel from './demo_carousel';
import { APP_PROPERTIES } from '../constants';

const headers = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  h6: ({ node, ...props }) => <small style={{ fontSize: 11 }} {...props} />,
};

const getDescription = (properties, comingSoonDescription, standardDescription) => {
  const isComingSoon = properties?.some(property => property.name === APP_PROPERTIES.COMING_SOON);

  if (isComingSoon && !!comingSoonDescription) return comingSoonDescription;

  return standardDescription;
};

const AboutSection = ({ listing }) => {
  return (
    <div className="about">
      <h4>About</h4>
      <ReactMarkdown components={headers} linkTarget="_blank">
        {getDescription(listing.properties, listing.coming_soon_description, listing.description)}
      </ReactMarkdown>
      {listing.demo_items && listing.demo_items.length > 0 && (
        <DemoCarousel demoItems={listing.demo_items} appSlug={listing.slug} />
      )}
    </div>
  );
};

AboutSection.propTypes = {
  listing: listingType.isRequired,
};

export default AboutSection;
